<template>
    <div>
        <div class="new m12">
            <div class="new-logo">
                <img src="../../assets/images/logo.png" alt="">
            </div>
            <div class="head">
                <div class="left">
                    <img src="../../assets/images/deng1.png" alt="">
                    <div class="xian"></div>
                </div>
                <div class="right">
                    <div class="title">在这里<br>我们研发<br>你想要的试剂盒</div>
                    <div class="text">
                        我们希望可以为各位老师、研发人员定制你们所期待的检测试剂。更灵敏、更简便、更全面，在这里提出你的一切需求，我们会尽我们所能。
                    </div>
                    <div class="btn" @click="$router.push('/opinion?id=3')">点击此处，开启属于你的试剂盒</div>
                </div>
            </div>

            <div class="deng">
                <div class="de"><img src="../../assets/images/deng2.png" alt=""></div>
                <div class="xian"></div>
                <div class="de"><img src="../../assets/images/deng3.png" alt=""></div>
            </div>

            <div class="flow">
                <div class="left">
                    <div class="flow-t">流程</div>
                    <div class="li">
                        <div class="li-l">
                            <div class="yuan"></div>
                            <div class="xian"></div>
                        </div>
                        <div class="li-r">
                            <div class="title">Plan</div>
                            <div class="sub">告诉我们您的需求</div>
                            <div class="text">如果您的实验中有以下情况： </div>
                            <div class="text">～试剂盒不够灵敏 </div>
                            <div class="text">～实验检测时操作太麻烦 </div>
                            <div class="text">～现在有的试剂盒规格太大或太小</div>
                            <div class="text">～目前市场上都无法找到试剂盒检测我的实验</div>
                            <div class="liu">您今天的<span @click="$router.push('/opinion?id=3')">留言</span>，可能是这个新产品研发的 起点。</div>
                        </div>
                    </div>
                    <div class="li">
                        <div class="li-l">
                            <div class="yuan"></div>
                            <div class="xian"></div>
                        </div>
                        <div class="li-r">
                            <div class="title">Design</div>
                            <div class="sub">让吐槽来的更猛烈一些</div>
                            <div class="info">越详尽，越贴合<br>关于实验过程中，任何您认为不满的小细节。<br>您都可以<span @click="$router.push('/opinion?id=3')">留言</span>告知我们。</div>
                        </div>
                    </div>
                    <div class="li">
                        <div class="li-l">
                            <div class="yuan"></div>
                            <div class="xian"></div>
                        </div>
                        <div class="li-r">
                            <div class="title">Try &Feedback</div>
                            <div class="sub">合不合手，试试才知道</div>
                            <div class="info">合不合手，试试才知道， <br>将会优先发放给提供意见和需求的老师哦 是回炉重造？还是新品上市？ <br>你们说了算！</div>
                        </div>
                    </div>
                    <div class="li">
                        <div class="li-l">
                            <div class="yuan"></div>
                        </div>
                        <div class="li-r">
                            <div class="title">Our Product</div>
                            <img src="../../assets/images/wnel.png" alt="">
                        </div>
                    </div>
                </div>
                <div class="right">
                    <div class="flow-t">记录</div>
                    <div class="li">
                        <div class="li-l">
                            <!-- <div class="yuan"></div> -->
                            <div class="xian"></div>
                        </div>
                        <div class="li-r li1-r">
                            <img src="../../assets/images/li-img.png" alt="">
                            <div>
                                有没有ROS检测的试剂盒？ —目前样品荧光和背景差别不明显，要灵敏度更高一些的试剂盒 —试剂盒对细胞毒性要小
                            </div>
                        </div>
                    </div>
                    <div class="li">
                        <div class="li-l">
                            <div class="yuan"><img src="../../assets/images/sjx.png" alt=""></div>
                            <div class="xian"></div>
                        </div>
                        <div class="li-r li2-r">
                            <div class="li-r-info">
                                <div class="title">ROS 检测试剂盒</div>
                                <div class="box">
                                    <div><i class="el-icon-caret-right"></i>高灵敏度</div>
                                    <div><i class="el-icon-caret-right"></i>毒性低</div>
                                    <div><i class="el-icon-caret-right"></i>选择性强</div>
                                </div>
                            </div>
                            <img src="../../assets/images/jilu-img.png" alt="">
                            <div class="boot"></div>
                        </div>
                    </div>
                    <div class="li">
                        <div class="li-l">
                            <div class="yuan"><img src="../../assets/images/sjx.png" alt=""></div>
                            <div class="xian"></div>
                        </div>
                        <div class="li-r li3-r">
                            <div class="leftL">
                                <div class="title">Liperfluo</div>
                                <div class="img">
                                    <img src="../../assets/images/jilu-img1.png" alt="">
                                </div>
                            </div>
                            <div class="rightL">
                                <div>溶解困难，导致荧光低</div>
                                <div class="img"> <img src="../../assets/images/xia.png" alt=""></div>
                                <div>2020年7月修改Liperfluo性能 </div>
                                <div class="red">比较旧版，更易溶解</div>
                                <div>～～～～～～～～～～～～～～</div>
                                <div>规格太大，使用不完</div>
                                <div class="img"> <img src="../../assets/images/xia.png" alt=""></div>
                                <div>2021年9月新增50μg小包装</div>
                                <div class="red">更多包装选择</div>
                            </div>
                            <div class="boot"></div>
                        </div>
                    </div>
                    <div class="li">
                        <div class="li-l">
                            <div class="xian"></div>
                        </div>
                        <div class="li-r li4-r">
                            <div class="info1">想要线粒体膜电位、线粒体量、线粒体ROS同时看，但是荧光通道重叠了。</div>
                            <div class="info2">市场上检测线粒体内ROS特异性和灵敏度还不够好。</div>
                            <div class="info3">现在用的T社探针，长时间染色时，细胞核也会被染色。</div>
                        </div>
                    </div>
                    <div class="li">
                        <div class="li-l">
                            <div class="yuan"><img src="../../assets/images/sjx.png" alt=""></div>
                            <div class="xian"></div>
                        </div>
                        <div class="li-r li5-r">
                            <div class="hea">
                                <div class="title">mtSOX</div>
                                <div class="info">
                                    <div><i class="el-icon-caret-right"></i>可以和JC-1共染，不占用传统FITC /PI通道</div>
                                    <div><i class="el-icon-caret-right"></i>对超氧化物选择型更高</div>
                                    <div><i class="el-icon-caret-right"></i>灵敏度更强</div>
                                </div>
                            </div>
                            <img class="hea-img" src="../../assets/images/hea-img.png" alt="">
                            <!-- <div class="box">
                                <div class="zi">
                                    <div class="title title1">Blue</div>
                                    <div class="img"><img src="../../assets/images/mt1.png" alt=""></div>
                                    <div class="text">核</div>
                                </div>
                                <div class="zi">
                                    <div class="title title2">Green</div>
                                    <div class="img"><img src="../../assets/images/mt2.png" alt=""></div>
                                    <div class="text">线粒体量</div>
                                </div>
                                <div class="zi">
                                    <div class="title title3">Red</div>
                                    <div class="img"><img src="../../assets/images/mt3.png" alt=""></div>
                                    <div class="text">膜电位</div>
                                </div>
                                <div class="zi">
                                    <div class="title title4">Deep Red</div>
                                    <div class="img"><img src="../../assets/images/mt4.png" alt=""></div>
                                    <div class="text">线粒体ROS</div>
                                </div>
                            </div> -->
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    data() {
        return {
        }
    },
    computed: {
    },
    methods: {
    }
}
</script>

<style lang="scss" scoped>
.m12 {
    width: 100%;
    max-width: 1200px;
    margin: 0 auto;
}
.new {
    margin-top: 44px;
    .new-logo {
        width: 363px;
        height: 126px;
    }
    .head {
        margin-top: 40px;
        display: flex;
        .left {
            width: 409px;
            margin-right: 159px;
            position: relative;
            img {
                margin-top: 45px;
                width: 409px;
                height: 502px;
            }
            .xian {
                position: absolute;
                z-index: -1;
                top: 268px;
                left: 332px;
                width: 861px;
                height: 8px;
                background: #333333;
            }
        }
        .right {
            flex: 1;
            .title {
                font-size: 65px;
                font-family: PingFang SC, PingFang SC-Medium;
                font-weight: 500;
                text-align: left;
                color: #0a2a56;
                line-height: 84px;
                letter-spacing: 3px;
            }
            .text {
                box-sizing: border-box;
                margin-top: 34px;
                width: 523px;
                height: 293px;
                background: url('../../assets/images/text-bg.png') no-repeat;
                background-size: 100% cover;
                padding: 90px 36px 0 50px;
                font-size: 24px;
                font-family: PingFang SC, PingFang SC-Regular;
                font-weight: 400;
                color: #333333;
                line-height: 30px;
                letter-spacing: 1px;
            }
            .btn {
                height: 50px;
                font-size: 36px;
                font-family: PingFang SC, PingFang SC-Regular;
                font-weight: 400;
                color: #155699;
                line-height: 50px;
                letter-spacing: 2px;
                cursor: pointer;
            }
        }
    }
    .deng {
        margin-top: 33px;
        display: flex;
        justify-content: space-between;
        position: relative;
        .de {
            width: 204px;
            height: 213px;
            img {
                width: 204px;
                height: 213px;
            }
        }
        .xian {
            position: absolute;
            top: 102px;
            left: 100px;
            width: 1020px;
            border-bottom: 2px dashed #333333;
            z-index: -1;
        }
    }

    .flow {
        display: flex;
        margin-top: 20px;
        .flow-t {
            font-size: 50px;
            font-family: PingFang SC, PingFang SC-Medium;
            font-weight: 500;
            text-align: left;
            color: #155699;
            line-height: 30px;
            letter-spacing: 3px;
            padding-left: 25px;
            margin-bottom: 43px;
        }
        .left {
            flex: 1;
            .li {
                display: flex;
                .li-l {
                    width: 50px;
                    margin-right: 20px;
                    display: flex;
                    flex-direction: column;
                    align-items: center;
                    .yuan {
                        width: 50px;
                        height: 50px;
                        border-radius: 50%;
                        background: #155699;
                    }
                    .xian {
                        flex: 1;
                        height: 100%;
                        border: 2px dashed #ccc;
                    }
                }
                .li-r {
                    flex: 1;
                    padding-bottom: 93px;
                    .title {
                        font-size: 50px;
                        font-family: PingFang SC, PingFang SC-Medium;
                        font-weight: 500;
                        text-align: left;
                        color: #333333;
                        letter-spacing: 3px;
                        position: relative;
                        top: -10px;
                    }
                    .sub {
                        font-size: 36px;
                        font-family: PingFang SC, PingFang SC-Medium;
                        font-weight: 500;
                        color: #333333;
                        letter-spacing: 2px;
                        margin-bottom: 14px;
                    }
                    .text {
                        font-size: 22px;
                        font-family: PingFang SC, PingFang SC-Regular;
                        font-weight: 400;
                        color: #333333;
                        line-height: 36px;
                        letter-spacing: 1px;
                    }
                    .liu {
                        font-size: 24px;
                        font-family: PingFang SC, PingFang SC-Medium;
                        font-weight: 500;
                        text-align: left;
                        color: #333333;
                        letter-spacing: 1px;
                        margin-top: 20px;
                        span {
                            color: #155699;
                            cursor: pointer;
                            font-weight: bold;
                        }
                    }
                    .info {
                        margin-top: 20px;
                        font-size: 22px;
                        font-family: PingFang SC, PingFang SC-Regular;
                        font-weight: 400;
                        text-align: left;
                        color: #333333;
                        line-height: 36px;
                        letter-spacing: 1px;
                        span {
                            color: #155699;
                            cursor: pointer;
                            font-weight: bold;
                        }
                    }
                    img {
                        margin-top: 11px;
                        width: 150px;
                        height: 36px;
                    }
                }
            }
        }
        .right {
            flex: 1;
            .li {
                display: flex;
                .li-l {
                    width: 50px;
                    margin-right: 20px;
                    display: flex;
                    flex-direction: column;
                    align-items: center;
                    .yuan {
                        width: 50px;
                        height: 50px;
                        text-align: center;
                        img {
                            width: 42px;
                            height: 47px;
                        }
                    }
                    .xian {
                        flex: 1;
                        height: 100%;
                        border: 2px dashed #ccc;
                    }
                }
                .li-r {
                    flex: 1;
                }
                .li1-r {
                    display: flex;
                    padding-bottom: 31px;
                    img {
                        width: 202px;
                        height: 208px;
                        margin-right: 30px;
                    }
                    > div {
                        margin-top: 15px;
                        width: 332px;
                        height: 193px;
                        background: url('../../assets/images/lu.png') no-repeat;
                        background-size: cover;
                        padding: 20px 9px 0 22px;
                        box-sizing: border-box;
                        font-size: 20px;
                        font-family: PingFang SC, PingFang SC-Regular;
                        font-weight: 400;
                        color: #333333;
                        line-height: 30px;
                        letter-spacing: 1px;
                    }
                }
                .li2-r {
                    display: flex;
                    flex-wrap: wrap;
                    > img {
                        width: 257px;
                        height: 178px;
                        object-fit: cover;
                    }
                    .li-r-info {
                        flex: 1;
                        margin-right: 24px;
                        .title {
                            font-size: 36px;
                            font-family: PingFang SC, PingFang SC-Medium;
                            font-weight: 500;
                            text-align: left;
                            color: #155699;
                            letter-spacing: 2px;
                        }
                        .box {
                            width: 100%;
                            height: 110px;
                            display: flex;
                            flex-direction: column;
                            justify-content: center;
                            border: 1px dashed #000;
                            margin-top: 20px;
                            box-sizing: border-box;
                            > div {
                                font-size: 20px;
                                font-family: PingFang SC, PingFang SC-Regular;
                                font-weight: 400;
                                text-align: left;
                                color: #333333;
                                letter-spacing: 1px;
                                line-height: 30px;
                                padding-left: 30px;
                                i {
                                    margin-right: 12px;
                                }
                            }
                        }
                    }
                    .boot {
                        width: 100%;
                        border-bottom: 2px dashed #333333;
                        margin-top: 26px;
                        margin-bottom: 24px;
                    }
                }
                .li3-r {
                    display: flex;
                    flex-wrap: wrap;
                    .boot {
                        width: 100%;
                        border-bottom: 2px dashed #333333;
                        margin-top: 26px;
                        margin-bottom: 24px;
                    }
                    .rightL {
                        width: 305px;
                        height: 364px;
                        background: url('../../assets/images/jilu-img2.png')
                            no-repeat;
                        background-size: 100% 100%;
                        padding-top: 73px;
                        > div {
                            text-align: center;
                            font-size: 20px;
                            font-family: PingFang SC, PingFang SC-Regular;
                            font-weight: 400;
                            color: #333333;
                            line-height: 30px;
                            letter-spacing: 1px;
                            margin-top: 6px;
                        }
                        .red {
                            color: #b03130;
                        }
                    }
                    .leftL {
                        flex: 1;
                        .title {
                            font-size: 36px;
                            font-family: PingFang SC, PingFang SC-Medium;
                            font-weight: 500;
                            text-align: left;
                            color: #155699;
                            letter-spacing: 2px;
                        }
                        .img {
                            margin-top: 17px;
                            margin-left: 35px;
                            width: 149px;
                            height: 268px;
                            img {
                                width: 149px;
                                height: 268px;
                            }
                        }
                    }
                }
                .li4-r {
                    padding-bottom: 47px;
                    > div {
                        width: 558px;
                        height: 117px;
                        padding: 32px 61px 0 74px;
                        font-size: 20px;
                        font-family: PingFang SC, PingFang SC-Regular;
                        font-weight: 400;
                        text-align: left;
                        color: #333333;
                        line-height: 30px;
                        box-sizing: border-box;
                    }
                    .info1 {
                        background: url('../../assets/images/info1.png')
                            no-repeat;
                        background-size: 100% 100%;
                    }
                    .info2 {
                        background: url('../../assets/images/info2.png')
                            no-repeat;
                        background-size: 100% 100%;
                        margin-top: 15px;
                    }
                    .info3 {
                        margin-top: 15px;
                        background: url('../../assets/images/info3.png')
                            no-repeat;
                        background-size: 100% 100%;
                    }
                }
                .li5-r {
                    .hea {
                        display: flex;
                        .title {
                            flex: 1;
                            font-size: 36px;
                            font-family: PingFang SC, PingFang SC-Medium;
                            font-weight: 500;
                            text-align: left;
                            color: #155699;
                            letter-spacing: 2px;
                        }
                        .info {
                            width: 383px;
                            height: 137px;
                            background: #ffffff;
                            border: 2px dashed #333333;
                            padding: 10px 15px;
                            border-radius: 6px;
                            box-sizing: border-box;
                            > div {
                                font-size: 20px;
                                font-family: PingFang SC, PingFang SC-Regular;
                                font-weight: 400;
                                text-align: left;
                                color: #333333;
                                line-height: 30px;
                                letter-spacing: 1px;
                                i {
                                    font-size: 20px;
                                }
                            }
                        }
                    }
                    .hea-img {
                        max-width: 100%;
                        object-fit: cover;
                        margin-top: 20px;
                    }
                    .box {
                        margin-top: 15px;
                        display: flex;
                        justify-content: space-between;
                        .zi {
                            width: 133px;
                            .title {
                                width: 100%;
                                height: 33px;
                                background: #2304fb;
                                line-height: 33px;
                                text-align: center;
                                font-size: 20px;
                                font-family: PingFang SC, PingFang SC-Regular;
                                font-weight: 400;
                                color: #ffffff;
                            }
                            .title1 {
                                background: #2304fb;
                            }
                            .title2 {
                                background: #0ab050;
                            }
                            .title3 {
                                background: #fd0010;
                            }
                            .title4 {
                                background: #7030a0;
                            }
                            .img {
                                margin-top: 20px;
                                width: 133px;
                                height: 133px;
                                img {
                                    width: 133px;
                                    height: 133px;
                                }
                            }
                            .text {
                                margin-top: 10px;
                                font-size: 20px;
                                font-family: PingFang SC, PingFang SC-Medium;
                                font-weight: 500;
                                text-align: center;
                                color: #333333;
                            }
                        }
                    }
                }
            }
        }
    }
}
</style>
